/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line
  
  // Fix for cart-items errors when elements are missing
  (function() {
    // Override the problematic cartAddEvents method
    const originalConnectedCallback = window.customElements.get('cart-items')?.prototype?.connectedCallback;
    
    if (originalConnectedCallback) {
      window.customElements.get('cart-items').prototype.connectedCallback = function() {
        try {
          // Call original method
          originalConnectedCallback.call(this);
        } catch (error) {
          // Silently catch errors from missing elements
          console.warn('Cart initialization error caught:', error.message);
          
          // Try to initialize only the essential parts
          this.cart = this.cartDrawer || this.cartPage;
          if (this.cart) {
            // Initialize only if cart exists
            this.cartEvents && this.cartEvents();
            this.cartRemoveEvents && this.cartRemoveEvents();
            this.cartUpdateEvents && this.cartUpdateEvents();
          }
        }
      };
    }
    
    // Also patch the cartAddEvents method if it exists
    if (window.customElements.get('cart-items')?.prototype?.cartAddEvents) {
      const originalCartAddEvents = window.customElements.get('cart-items').prototype.cartAddEvents;
      
      window.customElements.get('cart-items').prototype.cartAddEvents = function() {
        try {
          // Only add event listeners if elements exist
          if (this.cartTermsCheckbox) {
            originalCartAddEvents.call(this);
          }
        } catch (error) {
          console.warn('Cart events error caught:', error.message);
        }
      };
    }
  })();
  
  // Fix hero banner loading performance - IMMEDIATE execution
  (function() {
    // Function to fix hero images
    function fixHeroImages() {
      // Find all hero images in first section
      const heroSelectors = [
        '.shopify-section:first-child img',
        '#shopify-section-sections--hero img',
        '.section-hero:first-of-type img',
        '.hero:first-of-type img',
        '[data-section-type="hero"] img'
      ];
      
      heroSelectors.forEach(selector => {
        const images = document.querySelectorAll(selector);
        images.forEach(img => {
          // Force eager loading
          if (img.loading === 'lazy') {
            img.loading = 'eager';
          }
          
          // Remove lazy loading classes
          img.classList.remove('is-loading');
          
          // Force immediate visibility
          img.style.opacity = '1';
          img.style.transition = 'none';
          
          // Clean up parent containers
          let parent = img.parentElement;
          while (parent && parent !== document.body) {
            if (parent.classList.contains('is-loading')) {
              parent.classList.remove('is-loading');
            }
            if (parent.classList.contains('lazy-image')) {
              parent.style.background = 'transparent';
            }
            parent = parent.parentElement;
          }
          
          // If image has data-src, load it immediately
          if (img.dataset.src && !img.src) {
            img.src = img.dataset.src;
            delete img.dataset.src;
          }
        });
      });
    }
    
    // Run immediately
    fixHeroImages();
    
    // Run again when DOM is interactive
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixHeroImages);
    }
    
    // Also run on mutation observer for dynamic content
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          fixHeroImages();
        }
      });
    });
    
    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Stop observing after 5 seconds to prevent performance issues
    setTimeout(() => observer.disconnect(), 5000);
  })();
  
  // Hide Chatra button on mobile when cart drawer is open
  (function() {
    function isMobileViewport() {
      if (window.matchMedia) {
        return window.matchMedia('(max-width: 749px)').matches;
      }
      return window.innerWidth <= 749;
    }

    function setCartDrawerChatState(isOpenOnMobile) {
      const root = document.documentElement;
      if (!root) return;

      if (isOpenOnMobile) {
        root.classList.add('cart-drawer-open-mobile');
      } else {
        root.classList.remove('cart-drawer-open-mobile');
      }
    }

    document.addEventListener('theme:cart-drawer:open', function() {
      if (isMobileViewport()) {
        setCartDrawerChatState(true);
      }
    });

    document.addEventListener('theme:cart-drawer:close', function() {
      setCartDrawerChatState(false);
    });

    // If viewport is resized from mobile to desktop while drawer is open,
    // ensure chat is not left hidden.
    window.addEventListener('resize', function() {
      if (!isMobileViewport()) {
        setCartDrawerChatState(false);
      }
    });
  })();
  
  // Wait for performance optimizations to be available
  const initializeOptimizations = () => {
    if (typeof window.performanceOptimizations === 'undefined') {
      setTimeout(initializeOptimizations, 100);
      return;
    }
    
    const { OptimizedEventManager, createOptimizedThrottle, optimizedDOM } = window.performanceOptimizations;
    const eventManager = new OptimizedEventManager();
    
    // Custom optimized AJAX submit handler for Clerk elements
    const handleAjaxSubmit = (e) => {
      if (e.target.classList.contains('ajax-submit') || e.target.closest('.ajax-submit')) {
        const button = e.target.classList.contains('ajax-submit') ? e.target : e.target.closest('.ajax-submit');
        const form = button.closest('form');
        
        if (!form) return;
        
        // Prevent default form submission
        e.preventDefault();
        
        // Optimize button state changes
        optimizedDOM.batchDOMOperations([
          {
            type: 'write',
            callback: () => {
              button.classList.add('is-loading');
              button.disabled = true;
            }
          }
        ]);
        
        // Get form data
        const formData = new FormData(form);
        
        // Check if this is a drawer cart
        const isDrawerCart = document.querySelector('[data-cart-drawer]');
        
        // Optimized fetch with better error handling
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(response => {
          // Batch DOM updates for better performance
          optimizedDOM.batchDOMOperations([
            {
              type: 'write',
              callback: () => {
                button.classList.remove('is-loading');
                button.disabled = false;
              }
            }
          ]);
          
          if (response.status) {
            // Handle error
            console.error('Add to cart error:', response);
            return;
          }
          
          // Success - trigger cart refresh and open drawer
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          
          // Open cart drawer with error handling
          try {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
            } else {
              // Fallback: try alternative cart drawer methods
              const cartDrawerAlternative = document.querySelector('[data-cart-drawer]');
              if (cartDrawerAlternative) {
                cartDrawerAlternative.classList.add('is-open');
              }
            }
          } catch (error) {
            console.error('Error opening cart drawer:', error);
            // Fallback: try clicking the cart icon to open drawer
            const cartIcon = document.querySelector('[data-cart-drawer-toggle]');
            if (cartIcon) {
              cartIcon.click();
            }
          }
        })
        .catch(error => {
          // Remove loading state on error
          optimizedDOM.batchDOMOperations([
            {
              type: 'write',
              callback: () => {
                button.classList.remove('is-loading');
                button.disabled = false;
              }
            }
          ]);
          console.error('Add to cart error:', error);
        });
      } else {
        // Fall back to regular form submission for page cart
        const form = e.target.closest('form');
        if (form) {
          form.submit();
        }
      }
    };
    
    // Add optimized event listener for ajax submit
    eventManager.add(document, 'click', handleAjaxSubmit);
    
    // Additional performance optimizations
    
    // 1. Optimize scroll-based animations
    const optimizeScrollAnimations = () => {
      const animatedElements = document.querySelectorAll('[data-aos]');
      
      if (animatedElements.length > 0) {
        const { OptimizedIntersectionObserver } = window.performanceOptimizations;
        
        const animationObserver = new OptimizedIntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // Use requestAnimationFrame for smooth animations
              requestAnimationFrame(() => {
                entry.target.classList.add('aos-animate');
              });
              
              // Stop observing after animation
              animationObserver.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '50px',
          threshold: 0.1
        });
        
        animatedElements.forEach(element => {
          animationObserver.observe(element);
        });
      }
    };
    
    // 2. Optimize image loading
    const optimizeImageLoading = () => {
      const images = document.querySelectorAll('img[data-src]');
      
      if (images.length > 0) {
        const { OptimizedIntersectionObserver } = window.performanceOptimizations;
        
        const imageObserver = new OptimizedIntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              const src = img.getAttribute('data-src');
              
              if (src) {
                img.src = src;
                img.removeAttribute('data-src');
                img.classList.remove('is-loading');
              }
              
              imageObserver.unobserve(img);
            }
          });
        }, {
          rootMargin: '100px',
          threshold: 0.01
        });
        
        images.forEach(img => {
          imageObserver.observe(img);
        });
      }
    };
    
    // 3. Optimize form interactions
    const optimizeFormInteractions = () => {
      const forms = document.querySelectorAll('form');
      
      forms.forEach(form => {
        const inputs = form.querySelectorAll('input, textarea, select');
        
        inputs.forEach(input => {
          // Use optimized event listeners
          const handleInputChange = createOptimizedThrottle((e) => {
            // Validate input without blocking main thread
            requestAnimationFrame(() => {
              if (input.checkValidity) {
                input.checkValidity();
              }
            });
          }, 100);
          
          eventManager.add(input, 'input', handleInputChange);
        });
      });
    };
    
    // 4. Optimize search functionality
    const optimizeSearch = () => {
      const searchInputs = document.querySelectorAll('input[type="search"]');
      
      searchInputs.forEach(input => {
        const handleSearch = createOptimizedThrottle((e) => {
          const query = e.target.value.trim();
          
          if (query.length >= 2) {
            // Debounce search requests
            requestAnimationFrame(() => {
              // Perform search operation
              console.log('Searching for:', query);
            });
          }
        }, 300);
        
        eventManager.add(input, 'input', handleSearch);
      });
    };
    
    // 5. Optimize cart drawer interactions
    const optimizeCartDrawer = () => {
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer) {
        const cartItems = cartDrawer.querySelectorAll('[data-item]');
        
        cartItems.forEach(item => {
          const quantityInput = item.querySelector('input[name="updates[]"]');
          
          if (quantityInput) {
            const handleQuantityChange = createOptimizedThrottle((e) => {
              const newQuantity = parseInt(e.target.value, 10);
              
              if (newQuantity >= 0) {
                // Update cart item quantity
                requestAnimationFrame(() => {
                  console.log('Updating cart item quantity:', newQuantity);
                });
              }
            }, 500);
            
            eventManager.add(quantityInput, 'change', handleQuantityChange);
          }
        });
      }
    };
    
    // Initialize optimizations on DOM ready
    const initializeAllOptimizations = () => {
      try {
        optimizeScrollAnimations();
        optimizeImageLoading();
        optimizeFormInteractions();
        optimizeSearch();
        optimizeCartDrawer();
        
        console.log('Performance optimizations initialized successfully');
      } catch (error) {
        console.error('Error initializing performance optimizations:', error);
      }
    };
    
    // Run optimizations after DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllOptimizations);
    } else {
      initializeAllOptimizations();
    }
    
    // Clean up event listeners on page unload
    window.addEventListener('beforeunload', () => {
      eventManager.removeAll();
    });
  };
  
  // Initialize optimizations
  initializeOptimizations();

  // Allow scrolling inside Clerk live search even when page scroll is locked
  (function enableClerkScrollLockExceptions() {
    function markClerkScrollable() {
      // Clerk injects an element with .clerk-instant-search-container; mark it as scroll-lock-scrollable
      document.querySelectorAll('.clerk-instant-search-container').forEach(function(el){
        el.setAttribute('data-scroll-lock-scrollable', '');
        // make sure container can scroll via inline style if Clerk overrides
        el.style.webkitOverflowScrolling = 'touch';
        el.style.overflowY = 'auto';
        el.style.touchAction = 'pan-y';
      });
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', markClerkScrollable);
    } else {
      markClerkScrollable();
    }

    // Also observe for dynamic injection by Clerk
    const observer = new MutationObserver(function(mutations){
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          markClerkScrollable();
        }
      }
    });
    observer.observe(document.documentElement || document.body, { childList: true, subtree: true });

    // Cleanup after a while to avoid long-running observers
    setTimeout(function(){ try { observer.disconnect(); } catch(e){} }, 10000);
  })();

  // Fix sale badge to show only when selected variant is on sale
  (function() {
    function updateSaleBadgeForVariant(variant) {
      // Find all sale badges on the page
      const saleBadges = document.querySelectorAll('.sale-box');
      
      saleBadges.forEach(badge => {
        if (!variant) {
          // Hide badge if no variant selected
          badge.style.display = 'none';
          return;
        }
        
        const comparePrice = variant.compare_at_price;
        const salePrice = variant.price;
        
        // Check if this variant is on sale
        if (comparePrice && comparePrice > salePrice) {
          // Calculate sale percentage (floor to avoid overstatement)
          const salePercent = Math.floor(((comparePrice - salePrice) / comparePrice) * 100);
          
          // Update badge text and show it
          badge.textContent = `-${salePercent}%`;
          badge.style.display = 'inline-block';
        } else {
          // Hide badge if variant is not on sale
          badge.style.display = 'none';
        }
      });
    }
    
    // Listen for variant changes
    document.addEventListener('theme:variant:change', function(event) {
      const variant = event.detail.variant;
      updateSaleBadgeForVariant(variant);
    });
    
    // Also listen for product component variant changes
    document.addEventListener('DOMContentLoaded', function() {
      const productComponent = document.querySelector('product-component');
      if (productComponent) {
        productComponent.addEventListener('theme:variant:change', function(event) {
          const variant = event.detail.variant;
          updateSaleBadgeForVariant(variant);
        });
      }
    });
    
    // Initialize with current variant if available
    document.addEventListener('DOMContentLoaded', function() {
      // Try to get the current variant from the product form
      const variantSelect = document.querySelector('select[name="id"]');
      if (variantSelect && variantSelect.value) {
        // Get product data
        const productJson = document.querySelector('[data-product-json]');
        if (productJson) {
          try {
            const productData = JSON.parse(productJson.textContent);
            const currentVariant = productData.variants.find(v => v.id.toString() === variantSelect.value);
            if (currentVariant) {
              updateSaleBadgeForVariant(currentVariant);
            }
          } catch (error) {
            console.warn('Could not parse product data for sale badge update:', error);
          }
        }
      }
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
